<template>
  <nuttrema-layout-three-vertical>

    <participant-standard-header
       slot="top"
      :meta="meta"
      :showOnMobileAndTablet="showOnMobileAndTablet">
    </participant-standard-header>

    <template slot="middle">
      <nuttrema-empty-result
        v-if="!token"
        icon="far fa-qrcode">
        <template slot="text">
          <h1>{{ $t('label.missing_token') }}</h1>
          <h4>{{ $t('label.missing_token_help') }}</h4>
        </template>
      </nuttrema-empty-result>

      <template v-else>
        <nuttrema-loader v-if="PersonalEmailVerify.fetching || PersonalProfile.fetching"></nuttrema-loader>
        <form-personal-verify-email
           v-else
          :edit="false"
          :token="token"
          :PersonalProfile="PersonalProfile"
          :PersonalEmailVerify="PersonalEmailVerify"
          @submit="onSubmitForm"
          @cancel="onCancelEvent">
        </form-personal-verify-email>
      </template>
    </template>

  </nuttrema-layout-three-vertical>
</template>

<script>
import { get } from 'lodash';

import ResponsiveMonitor from 'components/mixins/responsive-monitor';
import ParticipantStandardHeader from 'components/pages/participant/shared/participant-standard-header';
import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';

import PageVerifyEmail from 'components/pages/shared/verify-email/page-personal-verify-email';

export default {
  name: 'page-participant-verify-email',
  mixins: [
    ResponsiveMonitor,
    PageVerifyEmail,
  ],
  components: {
    ParticipantStandardHeader,
    NuttremaLayoutThreeVertical,
  },
  computed: {
    error() {
      return get(this.PersonalEmailVerify, 'saveError');
    },
    saved() {
      return get(this.PersonalEmailVerify, 'saved');
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/participant/public/verify-email/page-participant-verify-email.vue